import {
  Button,
  Card,
  Col,
  Row,
  message,
  Tabs,
  Input,
  Spin,
  Table,
  Form,
  Modal,
  Drawer,
  type RadioChangeEvent,
  type TablePaginationConfig,
  Space
} from 'antd'
import { Select } from 'antd'
import React, { useEffect, useState } from 'react'
import GoogleChartOrEmpty from '../common/GoogleChartOrEmpty'
import { useNavigate } from 'react-router-dom'
import '../../asserts/css/custom.css'
import InstitutionUserService from '../../services/InstitutionUserService'
import { isConnectivityFailure } from '../../utils/errorPopup'
import {
  generateChartRefundDataMFinance,
  generateChartBidSecurityDataMFinance
} from '../../utils/generateChartData'
import type { ColumnsType, SorterResult } from 'antd/es/table/interface'
import {
  UserOutlined,
  BankOutlined,
  IdcardOutlined,
  PayCircleOutlined,
  BuildOutlined,
  FileExcelOutlined,
  FileProtectOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons'
import { type UploadChangeParam } from 'antd/es/upload'
import moment from 'moment/moment'
import { RefundAnalyticsDoughnut } from './RefundAnalyticsDoughnut'
import SupportStatsKpiCard from './SupportStatsKpiCard'
import PendingRefundBarChart, { type PendingRefundMonthRow } from './PendingRefundBarChart'

export const barOptions = {
  chart: {
    title: 'Bid Security Provided Per Month - All Years',
    subtitle: 'Amount Paid for Bid Security by Year and Month'
  },
  curveType: 'function',
  pointSize: 4,
  lineWidth: 2
}
export const barOptions2 = {
  chart: {
    title: 'Digital Refunded Amounts per Month',
    subtitle: 'Refunded Amount - 2023-Now'
  },
  curveType: 'function',
  pointSize: 4,
  lineWidth: 2
}

interface Role {
  id: string | number
  name: string
}

interface DataType {
  index: any
  key: React.Key
  bank_code: string
  transaction_reference: string
  debit_account_number: string
  debit_account_name: string
  beneficiary_account_name: string
  beneficiary_bank_name: string
  beneficiary_account_number: string
  transaction_currency: string
  amount: number
  reason: string
  status: string
  created_at: string
  updated_at: string
  totalPayments: string
  amountRequestedToBeRefund: string
  amountRequestedToBeRefundedInProgressStatus: string
  TotalNumberOfApplicantRequestedRefund: string
  notRequestedBidders: string
  UserRoles: string
}

const SystemSupportDashboardView: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const [stats, setStats] = React.useState<Record<string, any>>({})
  const [statsRefund, setStatsRefund] = React.useState<Record<string, any>>({})
  const [statsBailiffRefund, setStatsBailiffRefund] = React.useState<Record<string, any>>({})
  const [pendingRefundByMonth, setPendingRefundByMonth] = React.useState<PendingRefundMonthRow[]>(
    []
  )
  const [totalPaid, setTotalPaidAmount] = useState(0)
  const [certifiedCheckAmount, setCertifiedCheckAmount] = useState(0)
  const [bidGuaranteeAmount, setBidGuaranteeAmount] = useState(0)
  const [digitalPaymentAmount, setDigitalPaymentAmount] = useState(0)
  const [currentTime, setCurrentTime] = useState(new Date())
  const [activeTab, setActiveTab] = useState('bidders') // Default tab
  const [bailiffRefundRequestList, setBailiffRefundRequestList] = useState<DataType[]>([])
  const [refundRequestList, setRefundRequestList] = useState<DataType[]>([])
  const [totalAmount, setTotalAmount] = useState(0)
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({})
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [userAccountsList, setUserAccountsList] = useState([])
  const [paginating, setPaginating] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    total: 0
  })

  const [filterStatus, setfilterStatus] = useState('')
  const [RolesDescription, setRoleDescription] = useState('')
  const [UsersRoles, setUserRoles] = useState('')
  const [userRolesView, setUserRolesView] = useState<Role[]>([])
  const [selectedRole, setSelectedRole] = useState('')
  const [responseData, setResponseData] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [loading, setLoading] = useState(false)
  const [clear, setClear] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isSettingModalVisible, setIsSettingModalVisible] = useState(false)
  const [fileName, setFileName] = useState<string | null>(null)
  const [isUploadActive, setIsUploadActive] = useState(false)
  const [activeForm, setActiveForm] = useState<string | null>(null)
  const [auditLogs, setAuditLogs] = useState<any[]>([])
  const [auditLogsPagination, setAuditLogsPagination] = useState({ current: 1, pageSize: 20, total: 0 })
  const [loadingAuditLogs, setLoadingAuditLogs] = useState(false)
  const [showBidderSearch, setShowBidderSearch] = useState(false)
  const [searchNID, setSearchNID] = useState('')
  const [searchRefNumber, setSearchRefNumber] = useState('')
  const [bidderDetails, setBidderDetails] = useState<any>(null)
  const [refundDetails, setRefundDetails] = useState<any>(null)
  const [searchLoading, setSearchLoading] = useState(false)
  const [searchError, setSearchError] = useState('')
  const [refNumberError, setRefNumberError] = useState('')
  const [lastAutoSearchedNID, setLastAutoSearchedNID] = useState('')
  const [lastAutoSearchedRef, setLastAutoSearchedRef] = useState('')
  const [isBidderModalVisible, setIsBidderModalVisible] = useState(false)
  const [isRefundModalVisible, setIsRefundModalVisible] = useState(false)
  const onUserTypeChange = (value: string): null => {
    return null
  }
  const { Option } = Select
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleRadioChange = (e: RadioChangeEvent) => {
    setIsUploadActive(e.target.value === 'upload') // Set upload state based on radio button value
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const showModal = () => {
    setIsModalVisible(true)
  }

  const permissions = [
    'Read Access',
    'Write Access',
    'Admin Access',
    'Manage Settings',
    'View Reports',
    'Export Data'
  ]

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const showSettingsModal = () => {
    setIsSettingModalVisible(true)
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCancel = () => {
    setIsModalVisible(false)
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSettingsCancel = () => {
    setIsSettingModalVisible(false)
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOk = () => {
    navigate('/create-bank-details') // Navigate to the bank details creation page
    setIsModalVisible(false) // Close modal after navigation
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const customRequest = ({ file, onSuccess, onError }: any) => {
    // Mock upload function, you can implement real file upload logic
    setTimeout(() => {
      onSuccess('ok')
    }, 1000)
  }

  // Handle file upload change (for Excel file)
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleFileUpload = (info: UploadChangeParam) => {
    if (info.file.status === 'done') {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.success(`${info.file.name} file uploaded successfully.`)
    } else if (info.file.status === 'error') {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.error(`${info.file.name} file upload failed.`)
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleFormToggle = (formType: string) => {
    // If the clicked button matches the active form, toggle it off
    // Otherwise, set the new form as active (and close any other open forms)
    if (activeForm === formType) {
      setActiveForm(null)
    } else {
      setActiveForm(formType)
    }
  }

  // Search bidder by National ID
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleBidderSearch = () => {
    if (searchNID === '' || searchNID.trim().length === 0) {
      void message.warning('Please enter a valid National ID')
      return
    }

    setSearchLoading(true)
    setSearchError('')
    setBidderDetails(null)

    InstitutionUserService.getBidderByNID(searchNID.trim())
      .then((res: any) => {
        if (res?.data !== null && res?.data !== undefined && Array.isArray(res.data) && res.data.length > 0) {
          setBidderDetails(res.data[0])
          setIsBidderModalVisible(true)
          setShowBidderSearch(false)
          void message.success('Bidder details found!')
        } else {
          setSearchError('No bidder found with this National ID')
          void message.warning('No bidder found with this National ID')
        }
      })
      .catch((err: any) => {
        const errorMessage = err?.response?.status === 404
          ? 'No bidder found with this National ID'
          : (err?.message !== null && err?.message !== undefined) ? err.message : 'Error searching for bidder'
        setSearchError(errorMessage)
        void message.error(errorMessage)
      })
      .finally(() => {
        setSearchLoading(false)
      })
  }

  // Search bidder by Reference Number
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleRefNumberSearch = () => {
    if (searchRefNumber === '' || searchRefNumber.trim().length === 0) {
      void message.warning('Please enter a valid Reference Number')
      return
    }

    setSearchLoading(true)
    setRefNumberError('')
    setRefundDetails(null)

    InstitutionUserService.getRefundByTransactionRef(searchRefNumber.trim())
      .then((res: any) => {
        if (res?.data !== null && res?.data !== undefined && Array.isArray(res.data) && res.data.length > 0) {
          setRefundDetails(res.data[0])
          setIsRefundModalVisible(true)
          setShowBidderSearch(false)
          void message.success('Transaction details found!')
        } else {
          setRefNumberError('No transaction found with this Reference Number')
          void message.warning('No transaction found with this Reference Number')
        }
      })
      .catch((err: any) => {
        const errorMessage = err?.response?.status === 404
          ? 'No transaction found with this Reference Number'
          : (err?.message !== null && err?.message !== undefined) ? err.message : 'Error searching for transaction'
        setRefNumberError(errorMessage)
        void message.error(errorMessage)
      })
      .finally(() => {
        setSearchLoading(false)
      })
  }

  // Clear search
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClearSearch = () => {
    setSearchNID('')
    setSearchRefNumber('')
    setBidderDetails(null)
    setSearchError('')
    setRefNumberError('')
    setLastAutoSearchedNID('')
    setLastAutoSearchedRef('')
  }

  useEffect(() => {
    if (!showBidderSearch) return
    const nid = searchNID.trim()
    if (!/^\d{16}$/.test(nid) || nid === lastAutoSearchedNID) return

    const timer = setTimeout(() => {
      handleBidderSearch()
      setLastAutoSearchedNID(nid)
    }, 450)

    return () => { clearTimeout(timer) }
  }, [searchNID, showBidderSearch, lastAutoSearchedNID])

  useEffect(() => {
    if (!showBidderSearch) return
    const ref = searchRefNumber.trim()
    if (ref.length < 6 || ref === lastAutoSearchedRef) return

    const timer = setTimeout(() => {
      handleRefNumberSearch()
      setLastAutoSearchedRef(ref)
    }, 500)

    return () => { clearTimeout(timer) }
  }, [searchRefNumber, showBidderSearch, lastAutoSearchedRef])

  // Fetch Audit Logs
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const fetchAuditLogs = (page = 1, pageSize = 20) => {
    setLoadingAuditLogs(true)
    InstitutionUserService.getAuditLogs(pageSize, page)
      .then((res: any) => {
        if (res?.data !== null && res?.data !== undefined) {
          setAuditLogs(res.data)
          setAuditLogsPagination({
            current: res.meta.page,
            pageSize: res.meta.limit,
            total: res.meta.total
          })
        }
      })
      .catch((err: any) => {
        void message.error(err?.message ?? 'Failed to fetch audit logs')
      })
      .finally(() => {
        setLoadingAuditLogs(false)
      })
  }

  React.useEffect(() => {
    InstitutionUserService.SAdminStats()
      .then((res: any) => {
        const chartData = generateChartBidSecurityDataMFinance(
          res?.data?.bidSecurityBarData ?? []
        )
        setStats((prev) => ({
          ...prev,
          ...res?.data,
          chart: chartData
        }))
      })
      .catch((err) => {
        void message.error(err?.message)
      })
  }, [])

  React.useEffect(() => {
    InstitutionUserService.MFinanceRefundStats()
      .then((res: any) => {
        const chartRefundData = generateChartRefundDataMFinance(res?.data.barData)

        setStats((prev) => ({
          ...prev,
          ...res?.data,
          chartRefundData
        }))
      })
      .catch((err) => {
        void message.error(err?.message)
      })
  }, [])

  // Fetch refund stats for pie chart
  React.useEffect(() => {
    InstitutionUserService.RefundRequestStats()
      .then((res: any) => {
        setStatsRefund(res.data)
      })
      .catch((err) => {
        void message.error(err?.message)
      })

    InstitutionUserService.bailiffRefundRequestStats()
      .then((response: any) => {
        setStatsBailiffRefund(response.data)
      })
      .catch((err) => {
        void message.error(err?.message)
      })
  }, [])

  React.useEffect(() => {
    InstitutionUserService.GetPendingRefundRequestsByMonth(12)
      .then((res: any) => {
        if (res?.status === 200 && Array.isArray(res.data?.months)) {
          setPendingRefundByMonth(res.data.months as PendingRefundMonthRow[])
        } else {
          setPendingRefundByMonth([])
        }
      })
      .catch(() => {
        setPendingRefundByMonth([])
      })
  }, [])

  // Fetch MFinance stats for total paid calculation
  useEffect(() => {
    InstitutionUserService.MFinanceStats()
      .then((res: any) => {
        const certifiedCheckAmt = parseInt(res?.data?.certified_checks)
        const bidGuaranteeAmt = parseInt(res?.data?.bid_guarantees)
        const digitalPaymentAmt = parseInt(res?.data?.payments?.totalPayments)

        setCertifiedCheckAmount(isNaN(certifiedCheckAmt) ? 0 : certifiedCheckAmt)
        setBidGuaranteeAmount(isNaN(bidGuaranteeAmt) ? 0 : bidGuaranteeAmt)
        setDigitalPaymentAmount(isNaN(digitalPaymentAmt) ? 0 : digitalPaymentAmt)
      })
      .catch((err) => {
        void message.error(err?.message)
      })
  }, [])

  // Calculate total paid amount
  useEffect(() => {
    const totalPaidAmount = certifiedCheckAmount + bidGuaranteeAmount + digitalPaymentAmount
    setTotalPaidAmount(totalPaidAmount)
  }, [certifiedCheckAmount, bidGuaranteeAmount, digitalPaymentAmount])

  const clearFilter = (): void => {
    setfilterStatus('')
    setFromDate('')
    setToDate('')
    setClear(true)
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/no-shadow
  const handleTableChange = (pagination: any) => {
    setPagination(pagination) // Update pagination state on page change
  }

  useEffect(() => {
    if (activeTab === 'bidders') {
      const total = refundRequestList.reduce((acc, curr) => acc + curr.amount, 0)
      setTotalAmount(total)
    } else if (activeTab === 'bailiffs') {
      const total = bailiffRefundRequestList.reduce((acc, curr) => acc + curr.amount, 0)
      setTotalAmount(total)
    }
  }, [refundRequestList, bailiffRefundRequestList, activeTab])

  // UseEffect for fetching refund request data when needed
  useEffect(() => {
    OnRefundRequestSearch()
  }, [activeTab, pagination.pageSize, pagination.current, filterStatus, fromDate, toDate])

  const OnRefundRequestSearch = (event?: any): void => {
    setLoading(true)

    const service = activeTab === 'bidders'
      ? InstitutionUserService.GetPendingRefundRequestListByStatusFromBidders
      : InstitutionUserService.GetPendingRefundRequestListByStatusFromBailiffs

    service(
      pagination.pageSize,
      pagination.current,
      event?.target?.value,
      fromDate,
      toDate
    )
      .then((res: any) => {
        setLoading(false)

        if (res.status === 200) {
          const data = res?.data
          if (data === null || data === undefined || data.length === 0) {
            if (activeTab === 'bidders') {
              setRefundRequestList([])
              void message.info('No New Refund Request found')
            } else if (activeTab === 'bailiffs') {
              setBailiffRefundRequestList([])
              void message.info('No New Refund Request found')
            }
          } else {
            if (activeTab === 'bidders') {
              setRefundRequestList(data)
            } else if (activeTab === 'bailiffs') {
              setBailiffRefundRequestList(data)
            }
            setPagination((prev) => ({
              ...prev,
              total: res?.meta?.total
            }))
          }
        } else if (res.status === 404) {
          if (activeTab === 'bidders') {
            void message.info('No New refund request found')
            setRefundRequestList([])
          } else if (activeTab === 'bailiffs') {
            void message.info('No New refund request found')
            setBailiffRefundRequestList([])
          }
        }
      })
      .catch((err: any) => {
        setLoading(false)
        if (err?.message === 'Operation canceled due to new request.') {
          return
        }
        if (!isConnectivityFailure(err)) {
          void message.error(err?.message)
        }
        if (activeTab === 'bidders') {
          setRefundRequestList([])
        } else {
          setBailiffRefundRequestList([])
        }
        setPagination((prev) => ({
          ...prev,
          total: 0
        }))
      })
  }

  const onRolesView = (event?: any): void => {
    setLoading(true)
    InstitutionUserService.getUserRoles()
      .then((res: any) => {
        if (res.status === 200) {
          setUserRolesView(res?.data)

          setPaginating((prev) => ({
            ...prev,
            total: res?.meta?.total
          }))
          setLoading(false)
        }
      })
      .catch((err: any) => {
        if (err?.message !== 'Operation canceled due to new request.') {
          void message.error(err?.message)
        }
        setLoading(false)
      })
  }

  useEffect(() => {
    onRolesView()
  }, [])

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleChange = (value: string) => {
    setSelectedRole(value)
  }

  // Format date
  const formatDate = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }
    return date.toLocaleDateString(undefined, options)
  }

  // Format time
  const formatTime = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }
    return date.toLocaleTimeString(undefined, options)
  }

  const bailiffsColumns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (text, record, index) => {
        const pageNumber = (pagination.current !== 0) || 1
        const pageSize = (pagination.pageSize !== 0) || 10
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false
    },
    {
      title: 'Ref.No',
      dataIndex: 'transaction_reference',
      key: 'transaction_reference',
      width: 100,
      sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
      sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Names',
      dataIndex: 'beneficiary_account_name',
      key: 'beneficiary_account_name',
      width: 100,
      sorter: (a: any, b: any) => a?.beneficiary_account_name.localeCompare(b?.beneficiary_account_name),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_account_name' ? sortedInfo?.order : null,
      render: (text: string) => {
        return text
          .toLowerCase() // Convert all text to lowercase
          .replace(/\b\w/g, (char) => char.toUpperCase())
      }
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (_text: any, record: any) => {
        const amount = parseInt(record?.amount, 10)
        return amount.toLocaleString()
      },
      sorter: (a: any, b: any) => Number(a?.amount) - Number(b?.amount),
      sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
      ellipsis: true
    }
  ]

  const biddersColumns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (text, record, index) => {
        const pageNumber = (pagination.current !== 0) || 1
        const pageSize = (pagination.pageSize !== 0) || 10
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false
    },
    {
      title: 'Ref. No',
      dataIndex: 'transaction_reference',
      key: 'transaction_reference',
      width: 100,
      sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
      sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Names',
      dataIndex: 'beneficiary_account_name',
      key: 'beneficiary_account_name',
      width: 120,
      sorter: (a: any, b: any) => a?.beneficiary_account_name.localeCompare(b?.beneficiary_account_name),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_account_name' ? sortedInfo?.order : null,
      render: (text: string) => {
        return text
          .toLowerCase() // Convert all text to lowercase
          .replace(/\b\w/g, (char) => char.toUpperCase())
      }

    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (_text: any, record: any) => {
        const amount = parseInt(record?.amount, 10)
        return amount.toLocaleString()
      },
      sorter: (a: any, b: any) => Number(a?.amount) - Number(b?.amount),
      sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
      ellipsis: true
    }
  ]

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  interface ApiError {
    response?: {
      data: {
        message?: string
      }
    }
  }

  function isApiError(error: unknown): error is ApiError {
    return (
      typeof error === 'object' && error !== null &&
      'response' in error &&
      (error as ApiError).response?.data?.message !== undefined
    )
  }

  const onUserCreate = (values: any): void => {
    setLoading(true)
    InstitutionUserService.CreateUsersAccount(values)
      .then((res: any) => {
        setLoading(false)
        void message.success(res.message)
        navigate('/users-accounts-list')
      })
      .catch((err: any) => {
        setLoading(false)
        void message.error(err?.response?.data?.message)
      })
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onFinish = async (values: any) => {
    setLoading(true)

    try {
      // Extract role name, description, and selected permissions from the form values
      const roleName = values.role // Value from the 'role' select field
      const roleDescription = values.description // Value from the 'description' textarea
      const selectedPermissions = values.permissions // Selected permissions from checkbox group

      // Set the role name and description states
      setUserRoles(roleName)
      setRoleDescription(roleDescription)

      // Logging for debugging or tracking purposes
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.info(`Role: ${roleName}`)
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.info(`Description: ${roleDescription}`)
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.info(`Permissions: ${selectedPermissions.join(', ')}`)

      // Define permissionsRoles by generating permission-role associations
      const permissionsRoles = selectedPermissions.map((permission: any, index: number) => ({
        permissionId: `permission-id-${index + 1}`, // These IDs would need to come from the actual backend response
        roleId: `role-id-${index + 1}` // This is a placeholder for now; make sure this is correctly mapped from the backend
      }))

      try {
        void message.info(`Permissions Roles: ${JSON.stringify(permissionsRoles, null, 2)}`)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error stringifying permissionsRoles:', error)
      }

      // The body to send in the API request, matching the payload structure
      const body = {
        roleName, // The name of the role
        roleDescription, // The description of the role
        permissions: selectedPermissions.map((permission: any) => ({ name: permission })), // Send permissions in the required format (array of objects with 'name' key)
        permissionsRoles // Send permissionsRoles as an array of permission-role associations
      }

      // Call the CreateRolesAndPermissions service to submit the data
      const response = await InstitutionUserService.CreateRolesAndPermissions(body)
      setResponseData(response)

      // Check the response status and display the message
      if (response.status === 200) {
        // Success case: Display success message and reset the form
        void message.success(response.message) // Display the success message from backend
        form.resetFields()
        navigate('/dashboard') // Redirect to the user accounts page or relevant page
      } else {
        // Handle other cases (e.g., 400, 401, etc.)
        void message.error((Boolean(response.message)) || 'Failed to create role and permissions. Please try again.')
      }
    } catch (error) {
      // Log the error to the console for debugging
      // eslint-disable-next-line no-console
      console.error('Error creating roles and permissions:', error)

      // Use the type guard to check if the error is an ApiError
      if (isApiError(error)) {
        const errorMessage = ((error.response?.data?.message) != null) || 'An error occurred. Please try again.'
        void message.error(errorMessage)
      } else {
        void message.error('An error occurred. Please try again.')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    OnUserAccountsSearch()
    // eslint-disable-next-line
  }, [clear, paginating.current, paginating.pageSize])

  const OnUserAccountsSearch = (event?: any): void => {
    setLoading(true)
    InstitutionUserService.getUserAccountsList(
      paginating.pageSize as number,
      paginating.current as number,
      event?.target?.value,
      filterStatus,
      fromDate,
      toDate
    )
      .then((res: any) => {
        if (res.status === 200) {
          setUserAccountsList(res?.data)
          setPaginating((prev) => ({
            ...prev,
            total: res?.meta?.total
          }))
          setLoading(false)
        }
      })
      .catch((err: any) => {
        if (err?.message !== 'Operation canceled due to new request.') {
          void message.error(err?.message)
        }
        setLoading(false)
      })
  }

  const columnsViewMode: ColumnsType<DataType> = [
    {
      title: 'Date Added',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text: any, record: any) => (
        <span>{moment(record.created_at).format('YYYY-MM-DD')}</span>
      ),
      sorter: (a: any, b: any) => moment(a.created_at).unix() - moment(b.created_at).unix(),
      sortOrder: sortedInfo.columnKey === 'created_at' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Names',
      dataIndex: 'full_name',
      key: 'full_name',
      // sorter: (a, b) => a.full_name.localeCompare(b.full_name),
      sortOrder: sortedInfo.columnKey === 'full_name' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'ID Number',
      dataIndex: 'nid',
      key: 'nid',
      ellipsis: true
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      ellipsis: true
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      // sorter: (a, b) => a.email.localeCompare(b.email),
      sortOrder: sortedInfo.columnKey === 'email' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'User Type',
      dataIndex: 'role',
      key: 'role',
      ellipsis: true
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true
    }
  ]

  const columns: ColumnsType<DataType> = [
    {
      title: 'Date Added',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text: any, record: any) => (
        <span>{moment(record.created_at).format('YYYY-MM-DD')}</span>
      ),
      sorter: (a: any, b: any) => moment(a.created_at).unix() - moment(b.created_at).unix(),
      sortOrder: sortedInfo.columnKey === 'created_at' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Names',
      dataIndex: 'full_name',
      key: 'full_name',
      // sorter: (a, b) => a.full_name.localeCompare(b.full_name),
      sortOrder: sortedInfo.columnKey === 'full_name' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'ID Number',
      dataIndex: 'nid',
      key: 'nid',
      ellipsis: true
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      ellipsis: true
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      // sorter: (a, b) => a.email.localeCompare(b.email),
      sortOrder: sortedInfo.columnKey === 'email' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'User Type',
      dataIndex: 'role',
      key: 'role',
      ellipsis: true
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text: any, record: any) => (
        <div className="flex icon-container">
          <i
            className="far fa-eye cursor-pointer icon-style"
            onClick={() => {
              navigate('/view-user-account', { state: record })
            }}
          ></i>
        </div>
      )
    }
  ]

  const columnsEditRolesAndUserStatus: ColumnsType<DataType> = [
    {
      title: 'Date Added',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text: any, record: any) => (
        <span>{moment(record.created_at).format('YYYY-MM-DD')}</span>
      ),
      sorter: (a: any, b: any) => moment(a.created_at).unix() - moment(b.created_at).unix(),
      sortOrder: sortedInfo.columnKey === 'created_at' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Names',
      dataIndex: 'full_name',
      key: 'full_name',
      // sorter: (a, b) => a.full_name.localeCompare(b.full_name),
      sortOrder: sortedInfo.columnKey === 'full_name' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'ID Number',
      dataIndex: 'nid',
      key: 'nid',
      ellipsis: true
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      ellipsis: true
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      // sorter: (a, b) => a.email.localeCompare(b.email),
      sortOrder: sortedInfo.columnKey === 'email' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'User Type',
      dataIndex: 'role',
      key: 'role',
      ellipsis: true
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text: any, record: any) => (
        <div className="flex icon-container">
          <i
            className="far fa-eye cursor-pointer icon-style"
            onClick={() => {
              navigate('/view-user-account', { state: record })
            }}
          ></i>
        </div>
      )
    }
  ]
  const data = userAccountsList

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const generateCalendar = () => {
    const year = currentTime.getFullYear()
    const month = currentTime.getMonth()
    const today = currentTime.getDate()

    // Day names
    const dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']

    // Month name
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ]

    // Create calendar grid
    const calendarDays = []

    // Add day headers
    dayNames.forEach(day => {
      calendarDays.push(
        <div key={`header-${day}`} className="text-center text-xs font-medium py-1">
          {day}
        </div>
      )
    })

    // Get the current day of week (0-6)
    const currentDayOfWeek = new Date(year, month, today).getDay()

    // Calculate start date (go back to find Sunday of the week before)
    // This ensures we show the current week plus one week before and one after
    const startDay = today - currentDayOfWeek - 7

    // We'll show 3 weeks (21 days) centered around current week
    for (let i = 0; i < 21; i++) {
      const displayDay = startDay + i
      const displayDate = new Date(year, month, displayDay)
      const dayOfMonth = displayDate.getDate()
      const isCurrentMonth = displayDate.getMonth() === month
      const isToday = isCurrentMonth && dayOfMonth === today

      calendarDays.push(
        <div
          key={`day-${i}`}
          className={`text-center py-1 text-sm ${
            isToday
              ? 'bg-blue-500 text-white rounded-full font-bold'
              : isCurrentMonth
                ? ''
                : 'text-gray-300'
          }`}
        >
          {dayOfMonth}
        </div>
      )
    }

    return (
      <div className="mt-2">
        <div className="text-center font-medium mb-2">
          {monthNames[month]} {year}
        </div>
        <div className="grid grid-cols-7 gap-1">
          {calendarDays}
        </div>
      </div>
    )
  }

  return (
    <div className="w-full p-body">
      <style>{`
        .stats-card {
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .stats-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        }
        .chart-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .chart-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .enhanced-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .enhanced-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .enhanced-button {
          border-radius: 8px;
          font-weight: 600;
          transition: all 0.2s ease;
        }
        .enhanced-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      `}</style>

      {/* Enhanced Header Section - Matching FinanceDashboard */}
      <div className="px-5 py-4 border-b-slate-200 border border-solid w-full" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px'
      }}>
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 lg:justify-between lg:items-start">
          <div className="text-base font-bold w-full lg:w-2/3">
            <div className="flex items-center justify-center lg:justify-start mb-4">
              <div style={{
                background: 'var(--refund-theme-primary-soft)',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)'
              }}>
                <span style={{ fontSize: '24px', color: '#111827' }}>📊</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <h2 className="text-title font-bold" style={{
                  margin: 0,
                  color: '#111827'
                }}>
                  System Support Dashboard
                </h2>
                <p style={{
                  margin: '4px 0 0 0',
                  fontSize: '14px',
                  color: '#6b7280',
                  fontWeight: '500'
                }}>
                  🛠️ System Support • Analytics Dashboard
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bidder Search Section */}
      <div className="px-5 py-0" style={{ marginTop: '0px', marginBottom: '6px' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() => { setShowBidderSearch(!showBidderSearch) }}
            type="primary"
            size="large"
            shape="circle"
            title={showBidderSearch ? 'Close Bidder Search' : 'Search Bidder by National ID'}
            aria-label={showBidderSearch ? 'Close Bidder Search' : 'Search Bidder by National ID'}
            style={{
              background: showBidderSearch
                ? 'linear-gradient(135deg, #14532d 0%, #166534 100%)'
                : 'linear-gradient(135deg, #2f7a3f 0%, #37762f 100%)',
              border: 'none',
              color: '#ffffff',
              width: '40px',
              height: '40px',
              boxShadow: showBidderSearch
                ? '0 8px 20px rgba(20, 83, 45, 0.35)'
                : '0 8px 20px rgba(55, 118, 47, 0.32)',
              transition: 'all 0.25s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)'
              e.currentTarget.style.filter = 'brightness(1.05)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.filter = 'brightness(1)'
            }}
          >
            <i className={`fas ${showBidderSearch ? 'fa-times' : 'fa-search'}`} style={{ fontSize: '14px' }}></i>
          </Button>
        </div>

        <Drawer
          title="Filters - Bidder Lookup"
          placement="right"
          width={420}
          onClose={() => { setShowBidderSearch(false) }}
          open={showBidderSearch}
        >
          <div style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            color: '#0f172a',
            padding: '10px 14px',
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '15px',
            marginBottom: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: '1px solid #e2e8f0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <i className="fas fa-id-card text-xl"></i>
              <span>Bidder Information Lookup</span>
            </div>
            <span style={{ fontSize: '12px', color: '#475569', fontWeight: 500 }}>Quick Search</span>
          </div>

          <Row gutter={[12, 14]}>
            <Col xs={24}>
              <div style={{ marginBottom: '6px', fontWeight: '600', color: '#374151', fontSize: '13px' }}>
                <IdcardOutlined style={{ marginRight: '6px', color: '#3b82f6' }} />
                Search by National ID
              </div>
              <Input
                size="middle"
                placeholder="Enter 16-digit National ID"
                prefix={<IdcardOutlined style={{ color: '#3b82f6' }} />}
                value={searchNID}
                onChange={(e) => {
                  setSearchNID(e.target.value)
                  setSearchError('')
                }}
                maxLength={16}
                onPressEnter={handleBidderSearch}
                style={{
                  borderRadius: '8px',
                  border: searchError !== '' ? '2px solid #ef4444' : '1px solid #d1d5db'
                }}
              />
              {searchError !== '' && (
                <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>
                  <i className="fas fa-exclamation-circle mr-1"></i>
                  {searchError}
                </div>
              )}
            </Col>

            <Col xs={24}>
              <div style={{ marginBottom: '6px', fontWeight: '600', color: '#374151', fontSize: '13px' }}>
                <BankOutlined style={{ marginRight: '6px', color: '#10b981' }} />
                Search Refund Status by Reference Number
              </div>
              <Input
                size="middle"
                placeholder="Enter Reference Number"
                prefix={<BankOutlined style={{ color: '#10b981' }} />}
                value={searchRefNumber}
                onChange={(e) => {
                  setSearchRefNumber(e.target.value)
                  setRefNumberError('')
                }}
                onPressEnter={handleRefNumberSearch}
                style={{
                  borderRadius: '8px',
                  border: refNumberError !== '' ? '2px solid #ef4444' : '1px solid #d1d5db'
                }}
              />
              {refNumberError !== '' && (
                <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>
                  <i className="fas fa-exclamation-circle mr-1"></i>
                  {refNumberError}
                </div>
              )}
            </Col>

            <Col xs={24}>
              <div style={{ marginBottom: '6px', color: '#6b7280', fontSize: '13px', fontWeight: 600 }}>
                Actions
              </div>
              <Button
                size="middle"
                onClick={handleClearSearch}
                disabled={searchNID.trim() === '' && searchRefNumber.trim() === ''}
                style={{
                  borderRadius: '8px',
                  fontWeight: '600',
                  height: '34px',
                  width: '130px',
                  maxWidth: '100%',
                  background: 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)',
                  border: 'none',
                  color: 'white',
                  boxShadow: '0 3px 8px rgba(234, 88, 12, 0.28)'
                }}
              >
                <i className="fas fa-times mr-2"></i>
                Clear All
              </Button>
            </Col>
          </Row>
        </Drawer>
      </div>

      <div className="px-2 pt-0 pb-2 sm:px-3 sm:pt-0 sm:pb-3 md:px-3 md:pt-0 md:pb-3">
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24} md={16} xl={16}>
            <Row gutter={[8, 8]} style={{ width: '100%' }}>
              <Col xs={24} sm={12} md={8} xl={8}>
                <SupportStatsKpiCard
                  title="Added Institutions"
                  category="Total count"
                  value={stats?.institutions ?? 0}
                  accent="#4338ca"
                  icon={<BankOutlined />}
                />
              </Col>
              <Col xs={24} sm={12} md={8} xl={8}>
                <SupportStatsKpiCard
                  title="Provided"
                  category="Bid guarantees"
                  value={stats?.bid_guarantees ?? 0}
                  accent="#37762f"
                  icon={<FileProtectOutlined />}
                />
              </Col>
              <Col xs={24} sm={12} md={8} xl={8}>
                <SupportStatsKpiCard
                  title="Provided"
                  category="Certified checks"
                  value={stats?.certified_checks ?? 0}
                  accent="#0f766e"
                  icon={<SafetyCertificateOutlined />}
                />
              </Col>
            </Row>

            <Row gutter={[8, 8]} className="mt-2">
              <Col xs={24}>
                <Card
                  className="chart-card h-full"
                  style={{
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <div className="text-center overflow-auto" style={{ maxWidth: '100vw' }}>
                    <div style={{
                      background: 'var(--refund-theme-primary-soft)',
                      color: '#111827',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      fontWeight: '600',
                      fontSize: '18px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      marginBottom: '20px'
                    }}>
                      📊 Bid Security Provided Per Month
                    </div>
                    <GoogleChartOrEmpty
                      chartType="Line"
                      width="100%"
                      height="400px"
                      data={stats?.chart}
                      options={{
                        ...barOptions,
                        responsive: true,
                        maintainAspectRatio: false,
                        backgroundColor: 'transparent',
                        chartArea: {
                          backgroundColor: 'transparent'
                        }
                      }}
                    />
                  </div>
                </Card>
              </Col>
            </Row>
            <Row gutter={[8, 8]} style={{ marginTop: 16 }}>
              <Col xs={24}>
                <Card
                  className="chart-card h-full"
                  style={{
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <div className="text-center overflow-auto" style={{ maxWidth: '100vw' }}>
                    <div style={{
                      background: 'var(--refund-theme-primary-soft)',
                      color: '#111827',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      fontWeight: '600',
                      fontSize: '18px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      marginBottom: '20px'
                    }}>
                      📈 Digital Refunded Amounts per Month
                    </div>
                    <GoogleChartOrEmpty
                      chartType="Line"
                      width="100%"
                      height="300px"
                      data={stats?.chartRefundData}
                      options={{
                        ...barOptions2,
                        responsive: true,
                        maintainAspectRatio: false,
                        backgroundColor: 'transparent',
                        chartArea: {
                          backgroundColor: 'transparent'
                        }
                      }}
                    />
                    <PendingRefundBarChart rows={pendingRefundByMonth} chartHeight={260} />
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={8} xl={8}>
            <Row gutter={[8, 8]} className="h-full">
              <Col xs={24} md={24} xl={24}>
                <Card
                  className="enhanced-card h-full"
                  style={{
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <div className="text-center py-4 rounded-t-lg flex items-center justify-center" style={{
                    background: 'var(--refund-theme-primary-soft)',
                    boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)',
                    marginBottom: '16px',
                    borderRadius: '8px'
                  }}>
                    <div style={{
                      background: 'rgba(255,255,255,0.2)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '12px'
                    }}>
                      <i className="fas fa-tasks text-2xl" style={{ color: '#111827' }}></i>
                    </div>
                    <div className="text-xl font-bold" style={{
                      color: '#111827',
                      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>Quick Actions</div>
                  </div>

                  {/* View all institutions Button */}
                  <div className="p-2.5">
                    <Button
                      onClick={() => { navigate('/institutions-list') }}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-list mr-4 text-white text-xl"></i>
                      <span className="text-md">View all institutions</span>
                    </Button>
                  </div>

                  {/* View all bid security provided Button */}
                  <div className="p-2.5">
                    <Button
                      onClick={() => { navigate('/bid-guarantee-list') }}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-shield-alt mr-4 text-white text-xl"></i>
                      <span className="text-md">View all bid security provided</span>
                    </Button>
                  </div>
                  {/* View all bid security payments Button */}
                  <div className="p-2.5">
                    <Button
                      onClick={() => { navigate('/payment-list') }}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-money-check-alt mr-4 text-white text-xl"></i>
                      <span className="text-md">View all bid security payments</span>
                    </Button>
                  </div>

                  {/* Refund Analytics (Chart.js doughnut) */}
                  <div className="p-2.5 mt-4">
                    <Card
                      className="chart-card"
                      style={{
                        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                        borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                      }}
                    >
                      <div style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        padding: '10px 16px',
                        borderRadius: '8px',
                        fontWeight: '600',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        marginBottom: '16px'
                      }}>
                        📊 Refund Analytics
                      </div>

                      {/* Refund analytics doughnut + summary */}
                      {(() => {
                        const totalRefunded = (parseInt(statsRefund?.totalRefundPayments ?? '0') + parseInt(statsBailiffRefund?.totalPayments ?? '0'))
                        const remainingToRefund = totalPaid - totalRefunded

                        // Calculate percentages
                        const refundedPercentage = totalPaid > 0 ? ((totalRefunded / totalPaid) * 100).toFixed(2) : '0.00'
                        const remainingPercentage = totalPaid > 0 ? ((remainingToRefund / totalPaid) * 100).toFixed(2) : '0.00'

                        return (
                          <>
                            <RefundAnalyticsDoughnut
                              totalPaid={totalPaid}
                              totalRefunded={totalRefunded}
                              refundedColor="#37762f"
                              remainingColor="#f59e0b"
                            />

                            {/* Summary Stats with Percentages */}
                            <div style={{ marginTop: '16px' }}>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 12px',
                                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(102, 126, 234, 0.05) 100%)',
                                borderLeft: '4px solid #667eea',
                                borderRadius: '6px',
                                marginBottom: '10px'
                              }}>
                                <div>
                                  <div style={{ fontWeight: '600', fontSize: '12px', color: '#37762f' }}>Total Paid</div>
                                  <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>Bid Security Amount</div>
                                </div>
                                <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#667eea' }}>
                                  {totalPaid.toLocaleString()} Rwf
                                </span>
                              </div>

                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 12px',
                                background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(16, 185, 129, 0.05) 100%)',
                                borderLeft: '4px solid #10b981',
                                borderRadius: '6px',
                                marginBottom: '10px'
                              }}>
                                <div>
                                  <div style={{ fontWeight: '600', fontSize: '12px', color: '#37762f' }}>Refunded</div>
                                  <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>{refundedPercentage}% of Total</div>
                                </div>
                                <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#10b981' }}>
                                  {totalRefunded.toLocaleString()} Rwf
                                </span>
                              </div>

                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 12px',
                                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(245, 158, 11, 0.05) 100%)',
                                borderLeft: '4px solid #f59e0b',
                                borderRadius: '6px'
                              }}>
                                <div>
                                  <div style={{ fontWeight: '600', fontSize: '12px', color: '#37762f' }}>Remaining to Refund</div>
                                  <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>{remainingPercentage}% of Total</div>
                                </div>
                                <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#f59e0b' }}>
                                  {remainingToRefund.toLocaleString()} Rwf
                                </span>
                              </div>
                            </div>
                          </>
                        )
                      })()}
                    </Card>
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      {/* Bidder Details Modal */}
      <Modal
        title={null}
        open={isBidderModalVisible}
        onCancel={() => { setIsBidderModalVisible(false) }}
        footer={null}
        width={1200}
        style={{ top: 20 }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          color: 'white',
          padding: '16px 20px',
          margin: '-24px -24px 20px -24px',
          borderRadius: '8px 8px 0 0',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <UserOutlined style={{ fontSize: '24px' }} />
          <div>
            <div style={{ fontSize: '18px', fontWeight: '700' }}>Bidder Details</div>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>Complete information about the bidder</div>
          </div>
        </div>

        <Row gutter={[16, 16]}>
          {/* Personal Information */}
          <Col xs={24}>
            <Card
              style={{
                background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
                borderRadius: '12px',
                border: '2px solid #3b82f6',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.1)'
              }}
            >
              <div style={{
                fontSize: '16px',
                fontWeight: '700',
                color: '#1e40af',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                paddingBottom: '12px',
                borderBottom: '2px solid #3b82f6'
              }}>
                <UserOutlined style={{ fontSize: '20px' }} />
                Personal Information
              </div>

              <Row gutter={[16, 16]}>
                <Col xs={24} sm={8}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px', fontWeight: '600', textTransform: 'uppercase' }}>Full Name</div>
                  <div style={{ fontSize: '15px', fontWeight: '700', color: '#1f2937', padding: '8px 12px', background: 'white', borderRadius: '8px' }}>
                    {(bidderDetails?.full_name !== null && bidderDetails?.full_name !== undefined && bidderDetails?.full_name !== '') ? bidderDetails.full_name : (bidderDetails?.beneficiary_account_name !== null && bidderDetails?.beneficiary_account_name !== undefined && bidderDetails?.beneficiary_account_name !== '') ? bidderDetails.beneficiary_account_name : (bidderDetails?.beneficiary_name !== null && bidderDetails?.beneficiary_name !== undefined && bidderDetails?.beneficiary_name !== '') ? bidderDetails.beneficiary_name : (bidderDetails?.bidder_name !== null && bidderDetails?.bidder_name !== undefined && bidderDetails?.bidder_name !== '') ? bidderDetails.bidder_name : 'N/A'}
                  </div>
                </Col>

                <Col xs={24} sm={8}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px', fontWeight: '600', textTransform: 'uppercase' }}>
                    <IdcardOutlined /> National ID
                  </div>
                  <div style={{ fontSize: '15px', fontWeight: '700', color: '#1f2937', padding: '8px 12px', background: 'white', borderRadius: '8px' }}>
                    {(bidderDetails?.beneficiary_nid !== null && bidderDetails?.beneficiary_nid !== undefined && bidderDetails?.beneficiary_nid !== '') ? bidderDetails.beneficiary_nid : (bidderDetails?.bidder_nid !== null && bidderDetails?.bidder_nid !== undefined && bidderDetails?.bidder_nid !== '') ? bidderDetails.bidder_nid : (bidderDetails?.nid !== null && bidderDetails?.nid !== undefined && bidderDetails?.nid !== '') ? bidderDetails.nid : 'N/A'}
                  </div>
                </Col>

                <Col xs={24} sm={8}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px', fontWeight: '600', textTransform: 'uppercase' }}>Phone Number</div>
                  <div style={{ fontSize: '15px', fontWeight: '700', color: '#1f2937', padding: '8px 12px', background: 'white', borderRadius: '8px' }}>
                    {(bidderDetails?.beneficiary_phone_number !== null && bidderDetails?.beneficiary_phone_number !== undefined && bidderDetails?.beneficiary_phone_number !== '') ? bidderDetails.beneficiary_phone_number : (bidderDetails?.phone_number !== null && bidderDetails?.phone_number !== undefined && bidderDetails?.phone_number !== '') ? bidderDetails.phone_number : 'N/A'}
                  </div>
                </Col>

                <Col xs={24}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px', fontWeight: '600', textTransform: 'uppercase' }}>Email Address</div>
                  <div style={{ fontSize: '15px', fontWeight: '700', color: '#1f2937', padding: '8px 12px', background: 'white', borderRadius: '8px' }}>
                    {(bidderDetails?.email !== null && bidderDetails?.email !== undefined && bidderDetails?.email !== '') ? bidderDetails.email : 'N/A'}
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        {/* Bidders Bids Section */}
        {(bidderDetails?.bidders_bids !== null && bidderDetails?.bidders_bids !== undefined && Array.isArray(bidderDetails.bidders_bids) && bidderDetails.bidders_bids.length > 0) && (
          <div style={{ marginTop: '24px' }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '700',
              color: '#1f2937',
              marginBottom: '16px',
              padding: '12px 16px',
              background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981'
            }}>
              📋 Bidder&apos;s Bids History ({bidderDetails.bidders_bids.length} {bidderDetails.bidders_bids.length === 1 ? 'Bid' : 'Bids'})
            </div>

            <div style={{
              maxHeight: '400px',
              overflowY: 'auto',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '13px'
              }}>
                <thead>
                  <tr style={{
                    background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1
                  }}>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '700', color: '#37762f', borderBottom: '2px solid #d1d5db' }}>#</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '700', color: '#37762f', borderBottom: '2px solid #d1d5db' }}>Property ID</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '700', color: '#37762f', borderBottom: '2px solid #d1d5db' }}>Case Number</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '700', color: '#37762f', borderBottom: '2px solid #d1d5db' }}>Reference Number</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '700', color: '#37762f', borderBottom: '2px solid #d1d5db' }}>Bill ID</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '700', color: '#37762f', borderBottom: '2px solid #d1d5db' }}>Auction Status</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '700', color: '#37762f', borderBottom: '2px solid #d1d5db' }}>Created At</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '700', color: '#37762f', borderBottom: '2px solid #d1d5db' }}>Updated At</th>
                  </tr>
                </thead>
                <tbody>
                  {bidderDetails.bidders_bids.map((bid: any, index: number) => (
                    <tr key={bid.bb_id ?? index} style={{
                      background: index % 2 === 0 ? 'white' : '#f9fafb',
                      transition: 'background 0.2s'
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = '#f0fdf4' }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = index % 2 === 0 ? 'white' : '#f9fafb' }}
                    >
                      <td style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '600', color: '#6b7280' }}>{index + 1}</td>
                      <td style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '600', color: '#1f2937' }}>
                        {(bid?.property_id !== null && bid?.property_id !== undefined && bid?.property_id !== '') ? bid.property_id : 'N/A'}
                      </td>
                      <td style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '600', color: '#1f2937' }}>
                        {(bid?.execution_case_no !== null && bid?.execution_case_no !== undefined && bid?.execution_case_no !== '') ? bid.execution_case_no : 'N/A'}
                      </td>
                      <td style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '600', color: '#1f2937' }}>
                        {(bid?.ref_number !== null && bid?.ref_number !== undefined && bid?.ref_number !== '') ? bid.ref_number : 'N/A'}
                      </td>
                      <td style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: '600', color: '#1f2937' }}>
                        {(bid?.bill_id !== null && bid?.bill_id !== undefined && bid?.bill_id !== '') ? bid.bill_id : 'N/A'}
                      </td>
                      <td style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
                        <span style={{
                          padding: '4px 12px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '700',
                          background: bid?.auction_status === 'ONGOING' ? '#dbeafe' : bid?.auction_status === 'COMPLETED' ? '#d1fae5' : '#fef3c7',
                          color: bid?.auction_status === 'ONGOING' ? '#1e40af' : bid?.auction_status === 'COMPLETED' ? '#065f46' : '#92400e'
                        }}>
                          {(bid?.auction_status !== null && bid?.auction_status !== undefined && bid?.auction_status !== '') ? bid.auction_status : 'UNKNOWN'}
                        </span>
                      </td>
                      <td style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', color: '#6b7280' }}>
                        {(bid?.created_at !== null && bid?.created_at !== undefined && bid?.created_at !== '') ? moment(bid.created_at).format('YYYY-MM-DD HH:mm') : 'N/A'}
                      </td>
                      <td style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', color: '#6b7280' }}>
                        {(bid?.updated_at !== null && bid?.updated_at !== undefined && bid?.updated_at !== '') ? moment(bid.updated_at).format('YYYY-MM-DD HH:mm') : 'N/A'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div style={{ marginTop: '20px', textAlign: 'right' }}>
          <Button
            type="primary"
            size="large"
            onClick={() => { setIsBidderModalVisible(false) }}
            style={{
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              height: '45px',
              paddingLeft: '32px',
              paddingRight: '32px'
            }}
          >
            Close
          </Button>
        </div>
      </Modal>

      {/* Refund Transaction Details Modal */}
      <Modal
        title={null}
        open={isRefundModalVisible}
        onCancel={() => { setIsRefundModalVisible(false) }}
        footer={null}
        width={1200}
        style={{ top: 20 }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          color: 'white',
          padding: '16px 20px',
          margin: '-24px -24px 20px -24px',
          borderRadius: '8px 8px 0 0',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <PayCircleOutlined style={{ fontSize: '24px' }} />
          <div>
            <div style={{ fontSize: '18px', fontWeight: '700' }}>Refund Transaction Details</div>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>Complete refund and transaction information</div>
          </div>
        </div>

        {/* Transaction Information */}
        <Card
          style={{
            background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
            borderRadius: '12px',
            border: '2px solid #10b981',
            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.1)',
            marginBottom: '16px'
          }}
        >
          <div style={{
            fontSize: '16px',
            fontWeight: '700',
            color: '#065f46',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            paddingBottom: '12px',
            borderBottom: '2px solid #10b981'
          }}>
            <PayCircleOutlined style={{ fontSize: '20px' }} />
            Transaction Information
          </div>

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8}>
              <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px', fontWeight: '600', textTransform: 'uppercase' }}>Transaction Reference</div>
              <div style={{ fontSize: '15px', fontWeight: '700', color: '#1f2937', padding: '8px 12px', background: 'white', borderRadius: '8px' }}>
                {(refundDetails?.transaction_reference !== null && refundDetails?.transaction_reference !== undefined && refundDetails?.transaction_reference !== '') ? refundDetails.transaction_reference : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px', fontWeight: '600', textTransform: 'uppercase' }}>Amount</div>
              <div style={{ fontSize: '18px', fontWeight: '800', color: '#37762f', padding: '8px 12px', background: 'white', borderRadius: '8px', textAlign: 'center' }}>
                {parseInt((refundDetails?.amount !== null && refundDetails?.amount !== undefined) ? String(refundDetails.amount) : '0', 10).toLocaleString()} {(refundDetails?.transaction_currency !== null && refundDetails?.transaction_currency !== undefined && refundDetails?.transaction_currency !== '') ? refundDetails.transaction_currency : 'RWF'}
              </div>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px', fontWeight: '600', textTransform: 'uppercase' }}>Status</div>
              <div style={{
                fontSize: '13px',
                fontWeight: '700',
                color: refundDetails?.status === 'PAID' || refundDetails?.status === 'COMPLETED' ? '#37762f' : '#f59e0b',
                background: refundDetails?.status === 'PAID' || refundDetails?.status === 'COMPLETED' ? '#d1fae5' : '#fef3c7',
                padding: '8px 12px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                {(refundDetails?.status !== null && refundDetails?.status !== undefined && refundDetails?.status !== '') ? refundDetails.status : 'PENDING'}
              </div>
            </Col>
          </Row>
        </Card>

        {/* Beneficiary & Bidder Information */}
        <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
          <Col xs={24} md={12}>
            <Card
              style={{
                background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
                borderRadius: '12px',
                border: '2px solid #3b82f6',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.1)',
                height: '100%'
              }}
            >
              <div style={{
                fontSize: '16px',
                fontWeight: '700',
                color: '#1e40af',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                paddingBottom: '12px',
                borderBottom: '2px solid #3b82f6'
              }}>
                <UserOutlined style={{ fontSize: '20px' }} />
                Beneficiary Information
              </div>

              <Row gutter={[12, 12]}>
                <Col xs={24}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Account Name</div>
                  <div style={{ fontSize: '14px', fontWeight: '700', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.beneficiary_account_name !== null && refundDetails?.beneficiary_account_name !== undefined && refundDetails?.beneficiary_account_name !== '') ? refundDetails.beneficiary_account_name : 'N/A'}
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Bank Name</div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.beneficiary_bank_name !== null && refundDetails?.beneficiary_bank_name !== undefined && refundDetails?.beneficiary_bank_name !== '') ? refundDetails.beneficiary_bank_name : 'N/A'}
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Account Number</div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.beneficiary_account_number !== null && refundDetails?.beneficiary_account_number !== undefined && refundDetails?.beneficiary_account_number !== '') ? refundDetails.beneficiary_account_number : 'N/A'}
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={24} md={12}>
            <Card
              style={{
                background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                borderRadius: '12px',
                border: '2px solid #f59e0b',
                boxShadow: '0 4px 12px rgba(245, 158, 11, 0.1)',
                height: '100%'
              }}
            >
              <div style={{
                fontSize: '16px',
                fontWeight: '700',
                color: '#92400e',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                paddingBottom: '12px',
                borderBottom: '2px solid #f59e0b'
              }}>
                <UserOutlined style={{ fontSize: '20px' }} />
                Bidder Information
              </div>

              <Row gutter={[12, 12]}>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Full Name</div>
                  <div style={{ fontSize: '13px', fontWeight: '700', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.bidder_full_name !== null && refundDetails?.bidder_full_name !== undefined && refundDetails?.bidder_full_name !== '') ? refundDetails.bidder_full_name : 'N/A'}
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>National ID</div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.bidder_nid !== null && refundDetails?.bidder_nid !== undefined && refundDetails?.bidder_nid !== '') ? refundDetails.bidder_nid : 'N/A'}
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Phone Number</div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.bidder_phone_number !== null && refundDetails?.bidder_phone_number !== undefined && refundDetails?.bidder_phone_number !== '') ? refundDetails.bidder_phone_number : 'N/A'}
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Email</div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.bidder_email !== null && refundDetails?.bidder_email !== undefined && refundDetails?.bidder_email !== '') ? refundDetails.bidder_email : 'N/A'}
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        {/* Bailiff & Bid Security Information */}
        <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
          {/* Conditionally render Bailiff Information only if data exists */}
          {(refundDetails?.request_type === 'bailiff_refund_request' || (refundDetails?.bailiff_assignee !== null && refundDetails?.bailiff_assignee !== undefined && refundDetails?.bailiff_assignee !== '')) && (
            <Col xs={24} md={(refundDetails?.bid_security_ref_number !== null && refundDetails?.bid_security_ref_number !== undefined && refundDetails?.bid_security_ref_number !== '') ? 12 : 24}>
              <Card
                style={{
                  background: 'linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)',
                  borderRadius: '12px',
                  border: '2px solid #ec4899',
                  boxShadow: '0 4px 12px rgba(236, 72, 153, 0.1)',
                  height: '100%'
                }}
              >
                <div style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#9f1239',
                  marginBottom: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  paddingBottom: '12px',
                  borderBottom: '2px solid #ec4899'
                }}>
                  <BuildOutlined style={{ fontSize: '20px' }} />
                  Bailiff Information
                </div>

                <Row gutter={[12, 12]}>
                  <Col xs={24} sm={12}>
                    <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Assignee</div>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                      {(refundDetails?.bailiff_assignee !== null && refundDetails?.bailiff_assignee !== undefined && refundDetails?.bailiff_assignee !== '') ? refundDetails.bailiff_assignee : 'N/A'}
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>National ID</div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                      {(refundDetails?.bailiff_national_id !== null && refundDetails?.bailiff_national_id !== undefined && refundDetails?.bailiff_national_id !== '') ? refundDetails.bailiff_national_id : 'N/A'}
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Phone Number</div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                      {(refundDetails?.bailiff_phone_number !== null && refundDetails?.bailiff_phone_number !== undefined && refundDetails?.bailiff_phone_number !== '') ? refundDetails.bailiff_phone_number : 'N/A'}
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Email</div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                      {(refundDetails?.bailiff_email !== null && refundDetails?.bailiff_email !== undefined && refundDetails?.bailiff_email !== '') ? refundDetails.bailiff_email : 'N/A'}
                    </div>
                  </Col>
                  {(refundDetails?.property_id !== null && refundDetails?.property_id !== undefined && refundDetails?.property_id !== '') && (
                    <Col xs={24} sm={12}>
                      <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Property ID</div>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                        {refundDetails.property_id}
                      </div>
                    </Col>
                  )}
                  {(refundDetails?.execution_case_number !== null && refundDetails?.execution_case_number !== undefined && refundDetails?.execution_case_number !== '') && (
                    <Col xs={24} sm={12}>
                      <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Case Number</div>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                        {refundDetails.execution_case_number}
                      </div>
                    </Col>
                  )}
                </Row>
              </Card>
            </Col>
          )}

          <Col xs={24} md={(refundDetails?.request_type === 'bailiff_refund_request' || (refundDetails?.bailiff_assignee !== null && refundDetails?.bailiff_assignee !== undefined && refundDetails?.bailiff_assignee !== '')) ? 12 : 24}>
            <Card
              style={{
                background: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)',
                borderRadius: '12px',
                border: '2px solid #6366f1',
                boxShadow: '0 4px 12px rgba(99, 102, 241, 0.1)',
                height: '100%'
              }}
            >
              <div style={{
                fontSize: '16px',
                fontWeight: '700',
                color: '#3730a3',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                paddingBottom: '12px',
                borderBottom: '2px solid #6366f1'
              }}>
                <FileExcelOutlined style={{ fontSize: '20px' }} />
                Bid Security Information
              </div>

              <Row gutter={[12, 12]}>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Reference Number</div>
                  <div style={{ fontSize: '13px', fontWeight: '700', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.bid_security_ref_number !== null && refundDetails?.bid_security_ref_number !== undefined && refundDetails?.bid_security_ref_number !== '') ? refundDetails.bid_security_ref_number : 'N/A'}
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Type</div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {(refundDetails?.bid_security_type !== null && refundDetails?.bid_security_type !== undefined && refundDetails?.bid_security_type !== '') ? refundDetails.bid_security_type : 'N/A'}
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Amount Covered</div>
                  <div style={{ fontSize: '14px', fontWeight: '700', color: '#6366f1', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {parseInt((refundDetails?.bid_security_amount_covered !== null && refundDetails?.bid_security_amount_covered !== undefined) ? String(refundDetails.bid_security_amount_covered) : '0', 10).toLocaleString()} RWF
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Used</div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                    {refundDetails?.bid_security_used === true ? 'Yes' : 'No'}
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        {/* Additional Details */}
        <Card
          style={{
            background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
            borderRadius: '12px',
            border: '1px solid #d1d5db',
            marginBottom: '16px'
          }}
        >
          <div style={{
            fontSize: '16px',
            fontWeight: '700',
            color: '#37762f',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            paddingBottom: '12px',
            borderBottom: '2px solid #d1d5db'
          }}>
            <BankOutlined style={{ fontSize: '20px' }} />
            Additional Details
          </div>

          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12} md={8}>
              <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Created By</div>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                {(refundDetails?.created_by !== null && refundDetails?.created_by !== undefined && refundDetails?.created_by !== '') ? refundDetails.created_by : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Created At</div>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                {(refundDetails?.created_at !== null && refundDetails?.created_at !== undefined && refundDetails?.created_at !== '') ? moment(refundDetails.created_at).format('YYYY-MM-DD HH:mm') : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px', fontWeight: '600' }}>Updated At</div>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', padding: '6px 10px', background: 'white', borderRadius: '6px' }}>
                {(refundDetails?.updated_at !== null && refundDetails?.updated_at !== undefined && refundDetails?.updated_at !== '') ? moment(refundDetails.updated_at).format('YYYY-MM-DD HH:mm') : 'N/A'}
              </div>
            </Col>
          </Row>
        </Card>

        <div style={{ textAlign: 'right' }}>
          <Button
            type="primary"
            size="large"
            onClick={() => { setIsRefundModalVisible(false) }}
            style={{
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              height: '45px',
              paddingLeft: '32px',
              paddingRight: '32px'
            }}
          >
            Close
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default SystemSupportDashboardView
